import { render } from "./ExpandButton.vue?vue&type=template&id=eb5b413a&scoped=true&ts=true"
import script from "./ExpandButton.vue?vue&type=script&lang=ts"
export * from "./ExpandButton.vue?vue&type=script&lang=ts"

import "./ExpandButton.vue?vue&type=style&index=0&id=eb5b413a&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb5b413a"]])

export default __exports__